import React from "react";
import { FormHelperText, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import { FormLabel } from "../utils";

type FTPInputProps = {
    name: string;
    label: string;
    numericOnly?: boolean;
    maxLength?: number;
    className?: string;
    [key: string]: any;
};

const styles = makeStyles(() => ({
    root: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#4b5563",
                borderWidth: "1px",
            },
        },
        "& legend": { display: "none" },
        "& fieldset": { top: 0 },
        zIndex: 0,
    },
}));

export const FTPInput = ({ name, label, numericOnly = false, maxLength, ...props }: FTPInputProps) => {
    const classes = styles();
    const { control, trigger } = useFormContext();

    return (
        <div className={`flex flex-col ${props.className || ""}`}>
            <FormLabel>{label}</FormLabel>

            <Controller
                name={name}
                control={control}
                render={({ field, fieldState: { error } }) => (
                    <div>
                        <TextField
                            {...field}
                            {...props}
                            placeholder={label}
                            fullWidth
                            className={classes.root}
                            error={!!error}
                            inputProps={{
                                ...(props.inputProps || {}),
                                inputMode: numericOnly ? "numeric" : undefined,
                                maxLength: maxLength,
                            }}
                            onInput={(e: any) => {
                                if (numericOnly) {
                                    e.target.value = e.target.value.replace(/\D/g, "");
                                    field.onChange(e);
                                }
                                props.onInput?.(e);
                            }}
                            onBlur={(e) => {
                                trigger(name);
                                field.onBlur();
                                props.onBlur?.(e);
                            }}
                        />

                        {error && <FormHelperText error>{error.message}</FormHelperText>}
                    </div>
                )}
            />
        </div>
    );
};
